import * as MD from '@material-ui/core';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { I18N, ILocaleInfos } from '../../Store/I18n/Types';
import { IApplicationState } from '../../Store';
import '../../App.css';

import { History } from 'history';
import { RouteComponentProps } from 'react-router-dom';
import { IDashboardState, IFiltersDetail } from '../../Store/Dashboard/Types';
import { getDashboardDetail } from '../../Store/Dashboard/Actions';

import { ISearchState } from '../../Store/Search/Types';
import { IUserState } from '../../Store/User/Types';
import { ElectionType, ICircoFilters, IElectionDetailFilters, IElectionFilters, IElectionsState, PersonFunction } from '../../Store/Elections/Types';
import _ from 'lodash';
import { getDashboardCirconscription, getDashboardElectionDetail, getXlsDashboardCirconscription, getXlsDashboardElection, getXlsDashboardElectionDetail, saveCircoFilters, setElectionTable } from '../../Store/Elections/Actions';
import { Export } from '../Dashboard/Export';
import { BiWindowClose } from "react-icons/bi";
import { ElectionTableDashboard } from './ElectionTableDashboard';
import { ElectionTableDetails } from './ElectionTableDetails';

interface IPropsFromState {
  i18n: I18N;
  localeInfos: ILocaleInfos;
  router: RouteComponentProps<{}>;
  dashboard: IDashboardState;
  search: ISearchState;
  user: IUserState;
  elections: IElectionsState;
}

interface IPropsFromDispatch {
  getDashboardDetail: typeof getDashboardDetail
  setElectionTable: typeof setElectionTable
  getDashboardCirconscription: typeof getDashboardCirconscription
  getXlsDashboardElectionDetail: typeof getXlsDashboardElectionDetail
  getXlsDashboardElection: typeof getXlsDashboardElection
  getXlsDashboardCirconscription: typeof getXlsDashboardCirconscription
  saveCircoFilters: typeof saveCircoFilters
  getDashboardElectionDetail: typeof getDashboardElectionDetail
}

interface IState {
  activeTab: ElectionType;
  showTableDetails: boolean;
  selectedCell: any;
  selectedIndex: number;
  constituency_id: number[];
  constituency_str: string[];
  loaded_data: boolean;
  loaded_virt_data: boolean;
  isAllCirconscriptionsSelected: boolean;
  constituency_virt_id: number[];
  constituency_virt_str: string[];
  isAllCirconscriptionsVirtSelected: boolean;
  open: boolean;
  circMenuAnchor: HTMLElement | null;
  circMenuOpen: boolean;
  circVirtMenuAnchor: HTMLElement | null;
  circVirtMenuOpen: boolean;
  regional_data: any;
}

interface IOwnProps {
  history: History;
}

type AllProps =
  MD.WithTheme &
  MD.WithStyles &
  IPropsFromState &
  IPropsFromDispatch &
  IOwnProps;

const styles = (theme: any) => MD.createStyles({
  menus: {
    display: 'flex',
    flexFlow: 'column',
    flexWrap: 'wrap',
  },
  menuPopper: {
    position: "absolute",
    top: "130px",
    left: "40px",
    transform: " translate3d(444px, 41px, 0px)",
    willChange: "transform",
    zIndex: 1203,
    height: 600,
    overflow: 'auto'
  },
  closeWindow: {
    position: 'absolute',
    right: '20px',
    marginTop: '-20px',
    '&:hover': {
      color: 'red',
    }
  },
  searchButton: {
    float: "right",
    margin: 5,
    width: "50%",
    cursor: 'pointer',
  },
})

export class ElectionsPresContentComponent extends React.Component<AllProps, IState> {
  itemRefs: any
  public constructor(props: AllProps) {
    super(props);
    this.itemRefs = React.createRef();
    this.state = {
      activeTab: (props.elections.study_type_id === 30 || props.elections.study_type_id === 32) ? ElectionType.CIRCONSCRIPTION : ElectionType.NATIONAL,
      showTableDetails: false,
      selectedCell: null,
      selectedIndex: -1,
      constituency_id: [],
      constituency_str: [],
      loaded_data: false,
      loaded_virt_data: false,
      isAllCirconscriptionsSelected: true,
      constituency_virt_id: [],
      constituency_virt_str: [],
      isAllCirconscriptionsVirtSelected: false,
      open: false,
      circMenuAnchor: null,
      circMenuOpen: false,
      circVirtMenuAnchor: null,
      circVirtMenuOpen: false,
      regional_data: null,
    }
    this.itemRefs = [];
  }

  static getDerivedStateFromProps(props: AllProps, state: IState) {

    if (props.elections.circonscriptions.length > 0 && state.loaded_data === false) {
      state.constituency_id = props.elections.allCirconscriptionsId
      state.constituency_str = props.elections.allCirconscriptionsStr
      state.loaded_data = true
    }
    if (props.elections.circonscriptionsVirt.length > 0 && state.loaded_virt_data === false) {
      //state.constituency_virt_id = props.elections.allCirconscriptionsVirtId
      //state.constituency_virt_str = props.elections.allCirconscriptionsVirtStr
      //state.loaded_virt_data = false
    }
    if (props.elections.regional_data.length > 0 && state.regional_data === null) {
      state.regional_data = props.elections.regional_data
    }
    if (props.elections.tableType === ElectionType.CIRCONSCRIPTION) {
      state.activeTab = ElectionType.CIRCONSCRIPTION
    }
    return state
  }


  public componentDidUpdate(prevProps: AllProps, prevState: IState) {
    if (!_.isEqual(prevProps.elections.study_type_id, this.props.elections.study_type_id)) {
      this.setState({
        constituency_id: [],
        constituency_str: [],
        constituency_virt_str: [],
        constituency_virt_id: [],
        regional_data: []
      })
    }
    if (!_.isEqual(prevProps.elections.dashboard_elections_filters, this.props.elections.dashboard_elections_filters)) {
      this.setState({
        showTableDetails: false
      })
    }
  }

  private rowClick: any = (index: number, state: any, rowInfo: any | undefined, column: any) => {
    const { elections } = this.props;
    let filters: IElectionFilters = elections.time_allocation_filters as any
    let filters_details: IElectionDetailFilters = {
      media_ids: filters.media_ids,
      study_type_id: filters.study_type_id,
      date_end: filters.date_end,
      date_start: filters.date_start,
      time_slot_start: filters.time_slot_start,
      time_slot_end: filters.time_slot_end,
      program_editor_ids: filters.program_editor_ids,
      program_type_ids: filters.program_type_ids
    }
    if (rowInfo && column.Header !== '') {
      filters_details = {
        ...filters_details,
        political_group_id: rowInfo.original.political_group_id,
        detail_etude_id: rowInfo.original.detail_etude_id
      }
      if (column.parent !== undefined && column.parent.cid !== undefined) {
        filters_details = {
          ...filters_details,
          program_type_ids: [column.parent.cid]
        }
      }
      if (column.parent !== undefined && column.parent.id !== undefined && !filters_details.details_etude_id) {
        filters_details = {
          ...filters_details,
          detail_etude_id: parseInt(column.parent.id)
        }
      }
      if (column.Header === 'Soutiens') {
        filters_details = {
          ...filters_details,
          person_function: PersonFunction.SOUTIEN
        }
      } else if (column.Header === 'Candidats') {
        filters_details = {
          ...filters_details,
          person_function: PersonFunction.CANDIDAT
        }
      }
      let disableClick: boolean = false;
      if (rowInfo.original[column.id] === '--') {
        disableClick = true
      }
      if (!disableClick) {
        this.props.getDashboardElectionDetail(filters_details)
        this.setState({
          showTableDetails: true,
          selectedCell: rowInfo.original,
          selectedIndex: index
        })
      }
    }
  }
  private buildTable() {
    return (
      <div>
        {
          this.props.elections.timeAllocationsLoading ?
            <div style={{ paddingTop: 30 }}>
              {`${this.props.i18n._('Loading')} ...`}
            </div> :
            this.props.elections.timeAllocationResults === null ?
              <div style={{ paddingTop: 30 }}>
                {this.props.i18n._('Please select filters')}
              </div>
              :
              this.props.elections.time_allocation_hms.length === 0 ?
                <div style={{ paddingTop: 30 }}>
                  {this.props.i18n._('No results')}
                </div>
                :
                <ElectionTableDashboard
                  resizeTable={true}
                  data={this.props.dashboard.filters.display_format === 'duration' ? this.props.elections.time_allocation_hms : this.props.elections.time_allocation_percent}
                  columns={this.props.elections.time_allocation_columns}
                  rowClick={this.rowClick.bind(this, -1)}
                  showLogo={true}
                />
        }
      </div>
    )
  }

  private buildExport() {
    let filters: any = this.props.elections.isElectionPresedentielle ? this.props.elections.time_allocation_filters :
      this.props.elections.dashboard_elections_filters;
    return (
      <div style={{ position: 'absolute', right: '15px', display: 'inline-flex' }}>
        {filters !== null &&
          <Export title={this.props.i18n._("Relevés horodatés").toUpperCase()}
            exportAction={() => this.props.getXlsDashboardElectionDetail(filters)}
            filters={filters} exportType='xls' />
        }
        {filters !== null &&
          <Export
            exportAction={() => this.props.elections.tableType === ElectionType.CIRCONSCRIPTION || this.props.elections.tableType === ElectionType.CIRCONSCRIPTION_VIRTUELLE ?
              this.props.getXlsDashboardCirconscription(filters) :
              this.props.getXlsDashboardElection(filters)
            }
            filters={filters} exportType='xls' />
        }
      </div>
    )
  }
  private buildDetailsTable() {
    const { classes, i18n } = this.props;
    return (
      this.props.elections.isLoadingDetail ?
        <div style={{ paddingTop: 30 }}>
          {i18n._('Loading')}..
        </div>
        : this.props.elections.dashboardElectionDetail === null ?
          <div style={{ paddingTop: 30 }}>
            {i18n._('No results')}
          </div>
          :
          <>
            <div id='top-table-infos' className={classes.topTableInfos} style={{ paddingTop: 30 }}>
              <span id="table-name" className={classes.tableName}>
                {/*this.state.selectedCell*/}
              </span>
              <MD.IconButton
                className={classes.closeWindow}
                onClick={() => this.setState({
                  showTableDetails: false
                })}
              >
                <BiWindowClose title={i18n._('Close')} />
              </MD.IconButton>
            </div>
            {
              this.props.elections.dashboardElectionDetail !== null &&
              <ElectionTableDetails
                filters={this.props.elections.dasboardDetailsFilters}
                data={this.props.elections.dashboardElectionDetail}
                showFilters={true}
              />
            }
          </>
    )
  }

  public render(): React.ReactNode {
    return (
      <>
        {!this.state.showTableDetails ?
          <>
            <div style={{ paddingTop: 30, display: 'inline-flex' }}>
              {this.buildExport()}
            </div>
            {this.buildTable()}
          </>
          :
          this.buildDetailsTable()
        }
      </>
    )
  }

}

const mapStateToProps = ({ i18n, dashboard, search, user, elections }: IApplicationState, ownProps: RouteComponentProps<{}>) => {
  return {
    i18n: i18n.i18n,
    localeInfos: i18n.localeInfos,
    router: ownProps,
    dashboard,
    search,
    user,
    elections
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  getDashboardDetail: (filters: IFiltersDetail) => dispatch(getDashboardDetail(filters)),
  setElectionTable: (tableType: ElectionType) => dispatch(setElectionTable(tableType)),
  getDashboardCirconscription: (filters: IElectionFilters) => dispatch(getDashboardCirconscription(filters)),
  getXlsDashboardElectionDetail: (filters: IElectionFilters) => dispatch(getXlsDashboardElectionDetail(filters)),
  getXlsDashboardElection: (filters: IElectionFilters) => dispatch(getXlsDashboardElection(filters)),
  getXlsDashboardCirconscription: (filters: IElectionFilters) => dispatch(getXlsDashboardCirconscription(filters)),
  saveCircoFilters: (filters: ICircoFilters) => dispatch(saveCircoFilters(filters)),
  getDashboardElectionDetail: (filters: IElectionDetailFilters) => dispatch(getDashboardElectionDetail(filters))
});


export const ElectionsPresContent =
  connect(mapStateToProps, mapDispatchToProps)
    (MD.withTheme(MD.withStyles(styles)(ElectionsPresContentComponent)));
